import { ReactNode } from 'react';
import AcademicNavigation from './AcademicNavigation';
import PersonalInfoSidebar from './PersonalInfoSidebar';
import BackToTop from './BackToTop';

interface AcademicLayoutProps {
  children: ReactNode;
  showQuickLinks?: boolean;
  quickLinks?: {
    text: string;
    href: string;
    icon?: React.ComponentType<{ className?: string }>;
  }[];
}

export default function AcademicLayout({
  children,
  showQuickLinks = true,
  quickLinks
}: AcademicLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <AcademicNavigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <PersonalInfoSidebar
            showQuickLinks={showQuickLinks}
            quickLinks={quickLinks}
          />
          <div className="lg:col-span-3">
            {children}
          </div>
        </div>
      </div>
      <BackToTop />
    </div>
  );
}
